<mat-select #userGroupSelect>
  @for (group of userGroups; track group) {
    <mat-option
      value="{{group.group_name}}">
      {{ group.group_name }}
    </mat-option>
  }
</mat-select>
